import { Component } from '@angular/core';
import { LoadingService } from '../../core/services/loading';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-loading',
  imports: [CommonModule],
  templateUrl: './loading.html',
  styleUrl: './loading.scss',
})
export class LoadingComponent {
  constructor(public loadingService: LoadingService) { }
}
